<div class="justify-content-between vh-100 align-items-center d-flex">
    loading...
</div>